<template>
  <div class="topmenu">
    <Tag
      size="large"
      v-for="item in list"
      :key="item.Menu_ID"
      :name="item.Menu_ID"
      :checked="item.active"
      checkable color="primary"
      closable
      @on-change="handleSelect"
      @on-close="handleClose2"
    >{{ item.Menu_Name }}</Tag>
  </div>
</template>

<script>
export default {
  name: 'TopMenu',
  computed: {
    list: function () {
      return this.$store.state.TopMenu
    }
  },
  methods: {
    handleSelect (checked, name) {
      let MenuList = this.$store.state.TopMenu
      MenuList.forEach(item => {
        if (item.Menu_ID === name) {
          item.active = true
          this.$emit('MenuSelectHandle', item.path1, item.path2, item.Menu_Name, item.Menu_ID)
          if (checked) {
            this.$router.push({ name: item.Menu_UrlName })
          }
        } else {
          item.active = false
        }
      })
      this.$store.commit('setTopMenu', MenuList)
    },
    handleClose2 (event, name) {
      let MenuList = this.$store.state.TopMenu
      let IsActive = false // 检查是否在当前页
      for (let i = 0; i < MenuList.length; i++) {
        if (MenuList[i].Menu_ID === name) {
          IsActive = MenuList[i].active // 赋值当前激活状态
          MenuList.splice(i, 1)
        }
      }
      const k = MenuList.length
      // 如果关闭的页是激活状态的，则把激活状态转移
      if (IsActive && k > 0) {
        this.$emit('MenuSelectHandle', MenuList[k - 1].path1, MenuList[k - 1].path2, MenuList[k - 1].Menu_Name, MenuList[k - 1].Menu_ID)
        MenuList[k - 1].active = true
        if (MenuList[k - 1].Menu_UrlName !== '' || MenuList[k - 1].Menu_UrlName !== null) {
          this.$router.push({ name: MenuList[k - 1].Menu_UrlName })
        }
      }
      if (k === 0) {
        this.$router.push({ name: 'Home_home' }) // 全部关闭则跳转首页
      }
      this.$store.commit('setTopMenu', MenuList)
    }
  }
}
</script>
<style scoped>
 .topmenu >>> .ivu-tag:not(.ivu-tag-border):not(.ivu-tag-dot):not(.ivu-tag-checked) {
    background: #ffffff;
    border: 0;
    color: #515a6e;
}
.topmenu {
  width: 100%;
  height: 2.5rem;
  overflow: hidden;
}
</style>>
